import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddQualification() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/QualificationLookup?${searchParams.toString()}`;
  return (
    <AddLookup
      title="Add Qualification"
      alert="Qualification Added Successfully"
      addDataAPIEndpoint="/Qualification/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Qualification",
              name: "QL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "QL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        QL_Name: {
          required: true,
          
        },
        QL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddQualification;
